var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "enterprise-certification" },
    [
      _c("FormClose", { on: { "on-close": () => _vm.$emit("on-close") } }),
      _c("div", { staticClass: "ec-content" }, [
        _vm.current === 0
          ? _c("div", { staticClass: "text-center" }, [
              _c("div", { staticClass: "ec-title" }, [
                _vm._v("填写以下信息，即可体验Metacare智慧养老服务"),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-top": "10px",
                    "font-size": "14px",
                    "font-weight": "400",
                    color: "rgba(0, 0, 0, 0.45)",
                  },
                },
                [
                  _vm._v(
                    " 产品处于内测阶段，提交申请后请您耐心等待，后续我们的客服会与您取得联系并为您开通试用权限。 "
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _c("div", { staticClass: "ec-steps" }, [
          _c(
            "div",
            { staticClass: "steps-content" },
            [
              _vm.current === 0
                ? _c("EnterPriseStep1")
                : _vm.current === 1
                ? _c("EnterPriseStep3")
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "steps-opra" }, [
            _c("div", { staticClass: "steps-next", on: { click: _vm.next } }, [
              _vm._v(_vm._s(_vm.nextText)),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }